/**
 * The ИНН / БИН step's refusal, as an i18n key — never the API's raw code.
 *
 * The API refuses a company id with `invalid_tin`, as the MESSAGE of either a
 * `validation_error` (the DTO's length rule) or an `http_error` (the service's
 * full rule: placeholders, KZ's БИН/ИИН checksum), and a repeated change with
 * the code `tin_change_limit` and English prose. The form printed that message
 * as is, so a phone read the literal «invalid_tin» under «Проверить» (phone QA
 * on kaztender.com, 2026-10-16). Anything unrecognised — a network failure
 * included — gets the generic line rather than untranslated server text.
 */
export type CompanyErrorKey =
  | 'company.error.invalidTin'
  | 'company.error.changeLimit'
  | 'company.error.generic';

export function companyErrorKey(err: unknown): CompanyErrorKey {
  const code =
    err && typeof err === 'object' && 'code' in err ? (err as { code?: unknown }).code : undefined;
  const message = err instanceof Error ? err.message : undefined;
  if (code === 'invalid_tin' || message === 'invalid_tin') return 'company.error.invalidTin';
  if (code === 'tin_change_limit') return 'company.error.changeLimit';
  return 'company.error.generic';
}
